_ = require("lodash")

percentToFormattedString = ->
  (input, sizeDecimal=2, nonNumberStr='-') ->
    return nonNumberStr unless input?
    return nonNumberStr unless _.isFinite(input)
    return input.toString() if input is 0
    return input.toString() if input is 100
    parseFloat(input).toFixed(sizeDecimal)

module.exports = percentToFormattedString



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/number/percent-to-formatted-string.coffee